module.exports = __webpack_public_path__ + "img/CUBIC.261b3c78.png";